import { ICreateContratoServicoUseCase } from "../../../presentation/useCases/create/create_contrato_servico_use_case";
import { ICreateContratoUseCase } from "../../../presentation/useCases/create/create_contrato_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// CreateContratoServicoUseCase


export class CreateContratoServicoUseCase implements ICreateContratoServicoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createContratoServico(IdContrato: number, IdProdutoServico: number, Detalhamento: string | null, Quantidade: number | null, ValorUnitario: number | null, ValorTotal: number | null): Promise<void> {
    
    await this.repository.createContratoServico(
      IdContrato, IdProdutoServico, Detalhamento, Quantidade, ValorUnitario, ValorTotal
    );
  }
}
